import { useLang } from "@/context/LanguageContext";
import { CONTACT } from "@/i18n/content";
import { StarMark } from "@/components/site/StarMark";

export const Footer = () => {
  const { t } = useLang();
  const year = new Date().getFullYear();

  return (
    <footer data-testid="site-footer" className="bg-surface py-12 md:py-16">
      <div className="mx-auto max-w-[1440px] px-6 md:px-12">
        <div className="flex flex-col items-start justify-between gap-8 border-t border-line pt-10 md:flex-row md:items-center">
          <div className="flex items-center gap-3">
            <StarMark size={36} />
            <div>
              <p className="heading-serif text-xl text-forest">{t.brand}</p>
              <p className="text-sm text-ink-soft">{t.footer.tagline}</p>
            </div>
          </div>

          <div className="flex flex-col gap-1 md:items-end">
            <a
              href={CONTACT.tel}
              className="heading-serif text-2xl text-forest transition-colors hover:text-terracotta"
              data-testid="footer-phone"
            >
              {CONTACT.phoneDisplay}
            </a>
            <p className="text-xs tracking-wide text-ink-soft">
              © {year} Nakshtra Vidhya · {t.footer.rights}
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};
